import { Sparkles } from "lucide-react";
import { GlassCard } from "@/components/GlassCard";
import { useLanguage } from "@/i18n/LanguageContext";

export const PremiumTeaser = () => {
  const { t } = useLanguage();
  return (
    <GlassCard className="p-4 opacity-80" data-testid="premium-teaser-card">
      <div className="flex items-start gap-3">
        <div className="h-10 w-10 shrink-0 rounded-xl bg-amber-300/10 border border-amber-300/25 flex items-center justify-center">
          <Sparkles size={16} className="text-amber-300/80" />
        </div>
        <div>
          <p className="text-sm font-medium">{t("premium.title")}</p>
          <p className="text-xs text-[hsl(var(--muted-foreground))] mt-1 leading-relaxed">
            {t("premium.items")}
          </p>
        </div>
      </div>
    </GlassCard>
  );
};
